import React from 'react';

import ConfirmationDialog from 'Components/UI/ConfirmationDialog/NewDialog';
import { FDPrimaryActionButton } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import fr from 'facet-rest';
import { useModalContextSubmissionSuccessful } from 'Hooks/useRefreshEvent';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import useActionButton from './useActionButton';

export const AutomationActionButton = ({ automationSuggestionVariantResource }) => {
  const {
    onRevertAutomation,
    onCancel,
    onConfirmDelete,
    showConfirm,
    isLoading,
    onRunAutomation,
  } = useActionButton(automationSuggestionVariantResource);
  const { loadModalCollectionByLink, clearModalCollection } = useModalContext();
  const { refreshPageContentCollection } = usePageContentContext();

  useModalContextSubmissionSuccessful((evt, clearModalCollectionDependency) => {
    switch (evt.detail.response.meta().type()) {
      case 'FacetPlanAutomationOptionForBackdoorRoth':
        clearModalCollectionDependency();
        refreshPageContentCollection();
        break;
        /* no default */
    }
  }, [clearModalCollection]);

  if (!automationSuggestionVariantResource.link('self')) {
    return (<FDPrimaryActionButton
      disabled
      onClick={() => {}}
      color={'primary'}
      size={'md'}
      variant={'outlined'}
      label={'Run'}
      loading={isLoading}
      alignSelf="flex-end"
      round
      test={`facet-plan-automation-disabled-${automationSuggestionVariantResource.id()}`}
    />);
  }
  if (automationSuggestionVariantResource.meta().action('DELETE')) {
    return <>
      <FDPrimaryActionButton
        onClick={onRevertAutomation}
        color={'red'}
        size={'md'}
        variant={'outlined'}
        label={'Undo'}
        alignSelf="flex-end"
        round
        test={`facet-plan-automation-delete-${automationSuggestionVariantResource.id()}`}
      />
      {showConfirm ? (
        <ConfirmationDialog
          message={'Undoing an automation may delete elements that were created manually.'}/* IMPROVE IT */
          confirmLabel={'I understand'}
          onCancel={onCancel}
          onConfirm={onConfirmDelete}
          loading={isLoading}
          maxWidth={120}
          test={`facet-plan-automation-confirm-${automationSuggestionVariantResource.id()}`}
        />
      ) : null}
    </>;
  }


  const optionsModalRel = automationSuggestionVariantResource.relationship(fr.relationships.automationOptions.name);
  if (optionsModalRel) {
    return (<FDPrimaryActionButton
      onClick={() => loadModalCollectionByLink(optionsModalRel.link('related').url())}
      color={'primary'}
      size={'md'}
      variant={'outlined'}
      label={'Run'}
      loading={isLoading}
      alignSelf="flex-end"
      test={`facet-plan-automation-modal-${automationSuggestionVariantResource.id()}`}
      round
    />);
  }

  if (automationSuggestionVariantResource.meta().action('POST')) {
    return (<FDPrimaryActionButton
      onClick={onRunAutomation}
      color={'primary'}
      size={'md'}
      variant={'outlined'}
      label={'Run'}
      loading={isLoading}
      test={`facet-plan-automation-run-${automationSuggestionVariantResource.id()}`}
      round
    />);
  }


  return null;
};

AutomationActionButton.propTypes = {
  automationSuggestionVariantResource: PropTypes.object.isRequired,
};

export const ToolActionButton = ({ toolResource }) => {
  const { loadModalCollectionByLink } = useModalContext();

  const wizardRel = toolResource.relationship(fr.relationships.wizard.name);
  if (wizardRel) {
    return (
      <FDPrimaryActionButton
        onClick={() => loadModalCollectionByLink(wizardRel.link('related').url())}
        color={'primary'}
        size={'md'}
        variant={'outlined'}
        label={'Run'}
        test={`facet-plan-tool-${toolResource.id()}`}
      />
    );
  }

  return null;
};

ToolActionButton.propTypes = {
  toolResource: PropTypes.object.isRequired,
};
